import logger from '@cash-web/shared/util-logger'
import { useMutationStartWebAuthnRegistration } from '@cash-web/shared-data-access-api/react-query/useMutationStartWebAuthnRegistration'

import { getHeadersForWebAuthn } from './getHeadersForWebAuthn'

export function signalUnknownPasskey(credentialId: string, rpId: string) {
  if (typeof PublicKeyCredential === 'undefined' || !PublicKeyCredential.signalUnknownCredential) return

  void PublicKeyCredential.signalUnknownCredential({ credentialId, rpId }).catch(error => {
    logger.error(error instanceof Error ? error : new Error('Failed to signal unknown passkey'))
  })
}

export function useSignalUnknownPasskey() {
  const { mutateAsync: startRegistration } = useMutationStartWebAuthnRegistration({
    options: { optionalRequestHeaders: getHeadersForWebAuthn() },
  })

  return async function signalRemovedPasskey(credentialId: string) {
    if (typeof PublicKeyCredential === 'undefined' || !PublicKeyCredential.signalUnknownCredential) return

    try {
      const registration = await startRegistration({})
      if (registration.relying_party_identifier) {
        signalUnknownPasskey(credentialId, registration.relying_party_identifier)
      }
    } catch (error) {
      logger.error(error instanceof Error ? error : new Error('Failed to get passkey relying party ID'))
    }
  }
}
